import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  HostListener,
  ViewChild,
  ElementRef,
  HostBinding
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { KeyboardKey } from 'common/common/constants/keyboard-key.enum';

@Component({
  selector: 'app-genesys-insert-image',
  templateUrl: './genesys-insert-image.component.html',
  styleUrls: ['./genesys-insert-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysInsertImageComponent implements OnInit {
  private static readonly UrlRegexp =
    /^[A-Za-z][A-Za-z\d.+-]*:\/*(?:\w+(?::\w+)?@)?[^\s/]+(?::\d+)?(?:\/[\w#!:.?+=&%@\-/]*)?$/;

  @Output() addImage = new EventEmitter();
  @Output() closeInsertImage = new EventEmitter();

  @ViewChild('insertImageInput', { static: true }) insertImageInput: ElementRef<HTMLInputElement>;

  @HostBinding('attr.data-automation-id')
  private readonly _automationId = 'gc-editor-insert-image';

  imageForm = new UntypedFormGroup({
    imageLink: new UntypedFormControl('', [Validators.required, Validators.pattern(GenesysInsertImageComponent.UrlRegexp)])
  });

  ngOnInit(): void {
    this.insertImageInput.nativeElement.focus();
  }

  get imageLink() {
    return this.imageForm.get('imageLink');
  }

  insertImageLink(): void {
    if (this.imageForm.valid) {
      this.addImage.emit(this.imageLink.value);
      this.imageForm.reset();
    }
  }

  @HostListener('keydown', ['$event'])
  private _handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === KeyboardKey.Escape) {
      this.closeInsertImage.emit();
    }
  }
}
